module.exports = __webpack_public_path__ + "static/media/Kokomi.8ca5953f.png";